import { postResource } from 'utils/fetchUtils';
import config from '@/config/config';

const V1_API_BASE_URL = `${config.V1_API_HOST_NAME}/api/metrics`;
export const V2_API_BASE_URL = `${config.V2_API_HOST_NAME}/api/metrics/v2`;

export const postOne = ({ body }) => {
  if (body.hasOwnProperty('flyerIds') && body.flyerIds.length > 0) {
    postResource(V1_API_BASE_URL, {
      body,
    });
  }
};

export const postMetrics = ({ body }) => {
  if (body.hasOwnProperty('flyerIds') && body.flyerIds.length > 0) {
    return postResource(V2_API_BASE_URL, {
      body,
    });
  }
};
